import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appTable]',
    standalone: false
})
export class TableDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
